import { defineStore } from 'pinia';
import { ref } from 'vue';
import { ProductResource } from '@menu/Types/Resources/ProductResource';

export const usePreviewingProductStore = defineStore(
  'previewingProduct',
  () => {
    const previewingProduct = ref<ProductResource | null>(null);

    function setPreviewingProduct(product: ProductResource | null) {
      previewingProduct.value = product;
    }

    return {
      previewingProduct,
      setPreviewingProduct,
    };
  },
);
